export default class ElementGroup {
  constructor (name, initXRel, initYRel) {
    this.name = name
    this.initXRel = initXRel
    this.initYRel = initYRel

    this.isDraggable = false
    this.dragBoundFunc = null

    this.x = null
    this.y = null
  }

  setOnScene (sceneWidth, sceneHeight) {
    this.x = (sceneWidth * this.initXRel)
    this.y = (sceneHeight * this.initYRel)
  }

  setDraggable (isDraggable, dragBoundFunc) {
    this.isDraggable = isDraggable
    this.dragBoundFunc = dragBoundFunc
  }

  getConfig () {
    return {
      x: this.x,
      y: this.y,
      draggable: this.isDraggable,
      dragBoundFunc: this.dragBoundFunc
    }
  }
}
